export default __webpack_public_path__ + "static/media/House.9323a98c.jpg";